<template>
    <div class="patent_bottom">
		<div class="patent_title">长三角地区专利授权情况</div>
		<div class="patent_chart">
			<div class="chart_left">
				<div class="chart_title">发明专利增幅情况</div>
				<div id="barChart5" style="width:100%;height:220px;"></div>
			</div>
			<dv-decoration-2 :reverse="true" style="width:5px;height:150px;" />
			<div class="chart_right">
				<div class="chart_title">单位：千件</div>
				<div id="barChart6" style="width:100%;height:220px;"></div>
			</div>
		</div>
	</div>
</template>
<script>
    export default {
        data(){
            return{}
        },
        mounted() {},
        methods:{
			getData(list1,list2){
				this.drowChart5(list1);
				this.drowChart6(list2);
			},
			// 增幅
			drowChart5(list1) {
				let myChart = this.$echarts.init(document.getElementById('barChart5'));
				var names = list1.map(item =>item.name);
				var data = list1.map(item =>item.value);
				var displayData = data.map(v =>Math.abs(v))  //处理过后的数据
				var option =  {
					legend: {
						data: ["增幅"],
						left:'center',
						top: 0,
						textStyle: {
							color:"rgba(255,255,255,0.8)"
						},
						itemWidth: 10,
						itemHeight: 10,
					},
				    grid: {
				        top: '20%',
				        left: '28%',
				        right:'24%',
				        bottom: '0'
				    },
				    xAxis: {
				        type: 'value',
				        min: 0,
				        axisLine: {
				            show: false,
				        },
				        splitLine: {
				            show: false,
				        },
				        axisLabel: {
				            show: false,
				        },
				        axisTick: {
				            show: false,
				        },
				        max: 'dataMax',
				    },
				    yAxis: {
				        type: 'category',
				        inverse: true ,
				        splitLine: {
				            show: false,
				        },
				        axisLine: {
				            show: false,
				        },
				        axisLabel: {
				            show: true,
				            align: 'left',
				            color: '#B7E2F3',
				            fontSize: 16,
				            margin:60,
				        },
				        axisTick: {
				            show: false
				        },
				        data:names,
				    },
					color: [{
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [{
								offset: 0,
								color: '#EDCB5D'
							},
							{
								offset: 1,
								color: '#EB6B20'
							}
						]
					}, ],
				    series: {
				        name: '增幅',
				        type: 'bar',
				        barWidth:16,
						data: displayData,
				        label: {
				            normal: {
				                show: true,
				                position: 'right',
				                color: 'rgba(255,255,255,0.8)',
				                fontSize: 16,
								formatter:function(p){
									return data[p.dataIndex] > 0 ? (p.value + '%') :('-'+ p.value) + '%'
								}
				            }
				        },
				    }
				}
				myChart.setOption(option);
				window.addEventListener("resize", function() {
				  myChart.resize();
				});
			},
        	drowChart6(list2) {
        		let myChart = this.$echarts.init(document.getElementById('barChart6'));
				var names = list2.map(item =>item.name);
        		var option = {
        			tooltip: {
        				trigger: 'axis',
        				axisPointer: {
        					type: 'line',
        					lineStyle: {
        						color: 'red'
        					}
        				}
        			},
        			textStyle: {
        				color: '#fff',
        			},
        			grid: {
        				left: '0',
        				right: '0',
        				top: '20%',
        				bottom: '0',
        				containLabel: true
        			},
        			legend: {
        				itemWidth: 10,
        				itemHeight: 10,
        				itemGap: 24, // 设置间距
        				left: 'center',
        				data: ['发明', '实用新型','外观设计'],
        				textStyle: {
        					color: '#fff',
        				},
        			},
        			xAxis: [{
        				type: 'category',
        				data:names,
        				axisTick: {
        					alignWithLabel: true
        				},
        				axisLabel: {
        					interval: 0, //数据过多时不间隔显示名称
        				},
        				axisLine: { //X轴坐标线隐藏
        					show: false,
        				},
        			}],
        			yAxis: [{
        				show: false, //Y轴坐标线隐藏
        				type: 'value',
        				axisLabel : {   //Y轴隐藏过后产生留白
        					formatter: function(){
        						return "";
        					}
        				}
        			}],
        			series: [
        				{
        					name: '发明',
        					type: 'bar',
        					barWidth: '20%',
        					barGap: '10%',
        					label: {
        						show: true,
        						position: 'outside',
        						color: '#fff'
        					},
        					color: '#4FDEF5',
        					data:list2.sqfmzlList.map(item =>item.value)
        				},{
        					name: '实用新型',
        					type: 'bar',
        					barWidth: '20%',
        					barGap: '10%',
        					label: {
        						show: true,
        						position: 'outside',
        						color: '#fff'
        					},
        					color: '#00A5F5',
        					data:list2.sqsyzlList.map(item =>item.value)
        				},{
        					name: '外观设计',
        					type: 'bar',
        					barWidth: '20%',
        					barGap: '10%',
        					label: {
        						show: true,
        						position: 'outside',
        						color: '#fff'
        					},
        					color: '#EC9037',
        					data:list2.sqwgzlList.map(item =>item.value)
        				}
        			],
        		};
        		myChart.setOption(option);
        		window.addEventListener("resize", function() {
        			myChart.resize();
        		});
        	},
        }
    }
</script>